import { createSlice } from '@reduxjs/toolkit';
import { 
    addNews, 
    getAdminArticle,
    getPaginateArticles,
    homeLoadMore,
    getNews,
    getNewsCategory,
    getAdminImages,
    getNewsofC,
    headingStatusChange,
    getPaginateArticlebyStatus
 } from '../actions/news';

export const newsSlice = createSlice({
    name:'news',
    initialState:{
        homeSort:{
            sortby:"_id",
            order:"desc",
            limit:10,
            skip:0
        },
        loading:false,
        news:[],
        current:null,
        categories:[],
        images:[],
        editNews:null,
        imagelist:[]
    },
    reducers:{

        updateCategories:(state,action)=>{
            state.categories = action.payload
        }
    }
 ,extraReducers:(builder)=>{
    builder
    // ADD NEWS
    .addCase(addNews.pending,(state)=>{ state.loading = true })
    .addCase(addNews.fulfilled,(state,action)=>{ 
        state.loading = false;
        state.lastAdded = action.payload 
    })
    .addCase(addNews.rejected,(state)=>{ state.loading = false })


    

 

 // EDIT NEWS
.addCase(getAdminArticle.pending,(state)=>{ state.loading = true })
.addCase(getAdminArticle.fulfilled,(state,action)=>{ 
    console.log("999999999999");
    console.log(action.payload);
    console.log("999999999999");
    state.loading = false;
    state.editNews = action.payload
})
.addCase(getAdminArticle.rejected,(state)=>{ state.loading = false })



       // GET PAGINATE ARTICLES
       .addCase(getPaginateArticles.pending,(state)=>{ state.loading = true })
       .addCase(getPaginateArticles.fulfilled,(state,action)=>{ 
           state.loading = false;
           state.adminArticles = action.payload 
       })
       .addCase(getPaginateArticles.rejected,(state)=>{ state.loading = false })

       // HOME LOAD MORE
 .addCase(homeLoadMore.fulfilled,(state,action)=>{ 

    console.log("77777777777");
    state.homeSort.skip = action.payload.sort.skip
    state.news = action.payload.newState
})

// GET ARTICLE
.addCase(getNews.pending,(state)=>{ state.loading = true })
.addCase(getNews.fulfilled,(state,action)=>{ 
    console.log("9999999999995555555555");
    console.log(action.payload);
    console.log("99999999999955555");
    state.loading = false;
    state.current = action.payload;
    
})
.addCase(getNews.rejected,(state)=>{ state.loading = false })
//getNewsofC
.addCase(getNewsofC.pending,(state)=>{ state.loading = true })
.addCase(getNewsofC.fulfilled,(state,action)=>{ 
    console.log("99999999999955555");
    console.log(action.payload);
    console.log("99999999999955555");
    state.loading = false;
    state.current = action.payload
    state.imagelist=action.payload.imagesList
    

})
.addCase(getNewsofC.rejected,(state)=>{ state.loading = false })

 /// CATEGORY
 .addCase(getNewsCategory.fulfilled,(state,action)=>{ 
    state.categories = action.payload;

    console.log("1111");
    console.log(action.payload);
    console.log("1111");
})
// /// IMAGES LIST
// .addCase(getAdminImages.fulfilled,(state,action)=>{ 
//     state.images = action.payload.images;

//     console.log("22222");
//     console.log(action.payload.images);
//     console.log("22222");
// })



.addCase(getAdminImages.pending,(state)=>{ state.loading = true })
.addCase(getAdminImages.fulfilled,(state,action)=>{ 
    console.log("999999999999");
    console.log(action.payload);
    console.log("999999999999");
    state.loading = false;
    //state.current = action.payload;
    

    state.imagelist=action.payload;
    state.images =action.payload;
    console.log("99999999999955555");
    console.log(state.images.images);
    console.log("99999999999955555");
})
.addCase(getAdminImages.rejected,(state)=>{ state.loading = false })



.addCase(headingStatusChange.fulfilled,(state,action)=>{ 
    state.images = action.payload.images;

    console.log("3333333");
    console.log(action.payload);
    console.log("3333333");
})

// GET PAGINATE ARTICLES BY STATUS 
.addCase(getPaginateArticlebyStatus.pending,(state)=>{ state.loading = true })
.addCase(getPaginateArticlebyStatus.fulfilled,(state,action)=>{ 
    state.loading = false;
    state.adminArticles = action.payload 
})
.addCase(getPaginateArticlebyStatus.rejected,(state)=>{ state.loading = false })



}
})

 

export const { updateCategories } = newsSlice.actions
export default newsSlice.reducer;
